<template>
  <el-card>
    <!-- 表单 -->
    <div class="top">
      <div class="searchForm">
        <el-form
          :inline="true"
          ref="searchForm"
          :model="searchForm"
          class="searchForm"
          @submit.native.prevent
          @keyup.enter.native="searchList"
        >
          <el-form-item label="" prop="keyword">
            <el-input
              v-model="searchForm.name_fuzz"
              clearable
              placeholder="请输入知识库名称"
              @clear="searchList"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchList">查 询</el-button>
            <el-button @click="resetForm">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <el-button
          v-if="jurisdiction.aiAgentDatasets_agent_create"
          class="float-right"
          type="primary"
          @click="onAdd"
        >
          新建知识库
        </el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table :data="list">
      <el-table-column label="知识库名称" prop="name"></el-table-column>
      <el-table-column label="描述" prop="description"></el-table-column>
      <el-table-column label="数据源类型" prop="data_source_type">
        <template slot-scope="scope">
          {{
            { upload: '用户上传', 'db-data': '从数据库导入', 'db-cos': '从数据库cos链接导入' }[
              scope.row.data_source_type
            ]
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <template>
            <el-button @click="onDetail(scope.row)" type="text" size="small">文档列表</el-button>
            <el-button @click="onRetrieval(scope.row)" type="text" size="small">召回测试</el-button>
            <el-button
              v-if="jurisdiction.aiAgentDatasets_agent_edit"
              @click="onEdit(scope.row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="jurisdiction.aiAgentDatasets_agent_delete"
              @click="onDelete(scope.row)"
              type="text"
              size="small"
            >
              移除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />
    <create-edit-dataset
      :visible="visible"
      :row="editData"
      :type="openType"
      @close="visible = false"
      @refresh="getList"
    />
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateEditDataset from './components/createEditDataset.vue';
export default {
  components: { CreateEditDataset },
  data() {
    return {
      // 搜索表单
      searchForm: {
        name_fuzz: '',
      },
      payload: {
        limit: 10,
        offset: 0,
      },
      page: 1,
      pageSize: 10,
      total: 0,
      // 表格
      loading: false,
      list: [],
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentDatasets_agent_create',
        'aiAgentDatasets_agent_edit',
        'aiAgentDatasets_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  async created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const { datasets, total_count: total } = await this.$request({
          url: this.$api.listAgentDatasets,
          data: this.payload,
        });
        this.list = datasets;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    onEdit(row) {
      this.editData = row;
      this.openType = 'edit';
      this.visible = true;
    },
    onDetail(row) {
      this.$router.push({ name: `ai-dataset-documents`, query: { dataset_id: row.id } });
    },
    onRetrieval(row) {
      this.$router.push({ name: `ai-dataset-retrieval`, query: { dataset_id: row.id } });
    },
    async onDelete(row) {
      this.$confirm(`确定移除知识库[${row.name}]吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          id: row.id,
        };
        console.log(data);
        await this.$request({
          url: this.$api.deleteAgentDataSet,
          data,
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.payload.name_fuzz = this.searchForm.name_fuzz || '';
      this.getList();
    },
    resetForm() {
      this.searchForm.name_fuzz = '';
      delete this.payload.name_fuzz;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';
@import '@/styles/element/pagination.scss';
.top {
  display: flex;
  .searchForm {
    flex: 1;
  }
}
.app-select {
  width: 120px;
}
</style>
